module.exports = __webpack_public_path__ + "img/full_right_angle_corner_line.8846c20a.svg";